export default __webpack_public_path__ + "static/media/Group-3406_yono@2x.3f13f90a.png";